<template>
  <div class="col-12 col-xl-12">
    <div class="card mb-3 mb-xxl-5 me-xxl-4" style="margin-top: 4rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px">
        <div class="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <h6 class="text-white text-capitalize ps-3 pe-3" style="font-size: 1rem">
            {{ $t('subjects.tableTitle') }}
          </h6>
        </div>
      </div>

      <div class="card-body px-0 pb-2 pe-xl-3">
        <div class="table-responsive p-1 p-xl-4">
          <LoadingSpinner
            v-if="loading"
            :message="$t('subjects.loading')"
            class="py-5"
          />

          <template v-else>
            <div class="d-block d-xl-none">
              <div v-if="subjects.length === 0" class="text-center py-3 text-muted">
                <i class="fas fa-book fa-2x mb-2"></i>
                <p>{{ $t('subjects.empty') }}</p>
              </div>

              <div v-for="subject in subjects" :key="'mobile-' + subject.id" class="card mb-3 mx-2">
                <div class="card-body py-2">
                  <div class="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 class="mb-0 text-sm">{{ subject.name }}</h6>
                      <p class="text-xs text-muted mb-1">{{ $t('subjects.code') }}: {{ subject.code }}</p>
                      <p class="text-xs text-muted mb-0">{{ $t('subjects.class') }}: {{ subject.class_name }}</p>
                    </div>
                    <div class="d-flex">
                      <router-link
                        :to="{ name: 'subjects.topics', params: { id: subject.id } }"
                        class="btn btn-link text-info p-0 mx-1"
                        :title="$t('subjects.topics')"
                          v-can="'topics.display'"

                      >
                        <i class="fas fa-tags fa-xs"></i>
                      </router-link>
                      <button
                        v-if="subject.class_id"
                        @click="$emit('view-teachers', subject)"
                        class="btn btn-link text-info p-0 mx-1"
                        :title="$t('subjects.viewTeachers')"
                          v-can="'class_group_teachers.display'"

                      >
                        <i class="fas fa-chalkboard-teacher fa-xs"></i>
                      </button>
                      <router-link
                        v-if="subject.class_id"
                        :to="{ name: 'subject-grade-sheets', params: { subjectId: subject.id }, query: { class_id: subject.class_id } }"
                        class="btn btn-link text-success p-0 mx-1"
                        :title="$t('subjects.gradeSheet')"
                          v-can="'subject_grade_sheets.display'"

                      >
                        <i class="fas fa-file-alt fa-sm"></i>
                      </router-link>
                    </div>
                  </div>

                  <p class="text-xs mt-2 mb-1 text-truncate">
                    {{ subject.description || $t('subjects.noDescription') }}
                  </p>

                  <div class="d-flex justify-content-center">
                    <router-link
                      :to="{ name: 'subjects.edit', params: { id: subject.id } }"
                      class="btn btn-link text-secondary p-0 mx-1"
                      :title="$t('common.edit')"
                        v-can="'subjects.update'"

                    >
                      <i class="fas fa-edit fa-xs"></i>
                    </router-link>
                    <button
                      @click="openDeleteDialog(subject)"
                      class="btn btn-link text-danger p-0 mx-1"
                      :title="$t('common.delete')"
                      :disabled="isProcessing"
                        v-can="'subjects.delete'"

                    >
                      <i class="fas fa-trash fa-xs"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <table class="table align-items-center mb-0 d-none d-xl-table">
              <thead>
                <tr>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7">{{ $t('subjects.name') }}</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7">{{ $t('subjects.code') }}</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7">{{ $t('subjects.class') }}</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7">{{ $t('subjects.description') }}</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center pe-4">{{ $t('common.actions') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="subjects.length === 0">
                  <td colspan="5" class="text-center py-4 text-muted">
                    <i class="fas fa-book fa-2x mb-2"></i>
                    <p>{{ $t('subjects.empty') }}</p>
                  </td>
                </tr>

                <tr v-for="subject in subjects" :key="subject.id">
                  <td>
                    <div class="d-flex px-3 py-1">
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-md">{{ subject.name }}</h6>
                      </div>
                    </div>
                  </td>
                  <td><p class="text-xs font-weight-bold mb-0">{{ subject.code }}</p></td>
                  <td><p class="text-xs font-weight-bold mb-0">{{ subject.class_name }}</p></td>
                  <td>
                    <p class="text-xs mb-0 text-truncate" style="max-width: 200px;">
                      {{ subject.description || $t('subjects.noDescription') }}
                    </p>
                  </td>
                  <td class="align-middle text-center pe-4">
                    <div class="d-inline-flex">
                      <router-link
                        :to="{ name: 'subjects.topics', params: { id: subject.id } }"
                        class="btn btn-link text-info p-1 mx-1"
                        :title="$t('subjects.topics')"
                          v-can="'topics.display'"
                      >
                        <i class="fas fa-tags fa-sm"></i>
                      </router-link>
                      <button
                        v-if="subject.class_id"
                        @click="$emit('view-teachers', subject)"
                        class="btn btn-link text-info p-1 mx-1"
                        :title="$t('subjects.viewTeachers')"
                          v-can="'class_group_teachers.display'"
                      >
                        <i class="fas fa-chalkboard-teacher fa-sm"></i>
                      </button>
                      <router-link
                        v-if="subject.class_id"
                        :to="{ name: 'subject-grade-sheets', params: { subjectId: subject.id }, query: { class_id: subject.class_id } }"
                        class="btn btn-link text-success p-1 mx-1"
                        :title="$t('subjects.gradeSheet')"
                          v-can="'subject_grade_sheets.display'"
                      >
                        <i class="fas fa-file-alt fa-sm"></i>
                      </router-link>
                      <router-link
                        :to="{ name: 'subjects.edit', params: { id: subject.id } }"
                        class="btn btn-link text-secondary p-1 mx-1"
                        :title="$t('common.edit')"
                          v-can="'subjects.update'"
                      >
                        <i class="fas fa-edit fa-sm"></i>
                      </router-link>
                      <button
                        @click="openDeleteDialog(subject)"
                        class="btn btn-link text-danger p-1 mx-1"
                        :title="$t('common.delete')"
                        :disabled="isProcessing"
                          v-can="'subjects.delete'"
                      >
                        <i class="fas fa-trash fa-sm"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps } from "vue";
import LoadingSpinner from "@/components/common/LoadingSpinner.vue";

 defineProps({
  subjects: {
    type: Array,
    required: true,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const isProcessing = ref(false);
const emit = defineEmits(["delete-subject"]);

const openDeleteDialog = (subject) => {
  emit("delete-subject", subject);
};
</script>
